import FuseLoading from '@fuse/core/FuseLoading';
import AppErrorBoundary from 'app/components/AppErrorBoundary/AppErrorBoundary';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * React Suspense defaults
 * For to Avoid Repetition
 */ // Suspense does not catch a rejected import(), hence the boundary inside it.
function FuseSuspense(props) {
  return (
    <React.Suspense fallback={<FuseLoading {...props.loadingProps} />}>
      <AppErrorBoundary>{props.children}</AppErrorBoundary>
    </React.Suspense>
  );
}

FuseSuspense.propTypes = {
  loadingProps: PropTypes.object,
};

FuseSuspense.defaultProps = {
  loadingProps: {
    delay: 0,
  },
};

export default FuseSuspense;
